var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-apex-charts',{attrs:{"type":"area","height":"450","options":_vm.optionsObj,"series":_vm.seriesList}})
}
var staticRenderFns = []

export { render, staticRenderFns }